module.exports = __webpack_public_path__ + "media/img/pages/career-starter/hero-fr-fcf7f9c5c7880d7e0ecbad585bb45de2.png";